import { render, staticRenderFns } from "./kbjihua.vue?vue&type=template&id=35eb80be&scoped=true"
import script from "./kbjihua.vue?vue&type=script&lang=js"
export * from "./kbjihua.vue?vue&type=script&lang=js"
import style0 from "./kbjihua.vue?vue&type=style&index=0&id=35eb80be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb80be",
  null
  
)

export default component.exports